import React from 'react';
import { Table, Input, Button } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import type { F1041 } from '../../../services/companyApi';

interface Props {
  isEditing: boolean;
  addresses: F1041[];
  setAddresses: (v: F1041[]) => void;
  companyCode: string;
}

const Tab2Addresses: React.FC<Props> = React.memo(({ isEditing, addresses, setAddresses, companyCode }) => {
  const updateRow = (idx: number, field: keyof F1041, value: string | number) => {
    const next = [...addresses];
    next[idx] = { ...next[idx], [field]: value };
    setAddresses(next);
  };

  const addRow = () => {
    const maxSeq = addresses.reduce((m, a) => Math.max(m, a.f1041_02), 0);
    setAddresses([...addresses, {
      f1041_01: companyCode, f1041_02: maxSeq + 1, f1041_11: '', f1041_12: '', f1041_13: '', f1041_14: '',
    }]);
  };

  const deleteRow = (idx: number) => {
    setAddresses(addresses.filter((_, i) => i !== idx));
  };

  const columns = [
    { title: '序', dataIndex: 'f1041_02', width: 50, render: (_: number, __: F1041, i: number) => i + 1 },
    { title: '類別', dataIndex: 'f1041_11', width: 100,
      render: (v: string, _: F1041, i: number) => isEditing
        ? <Input size="small" value={v} onChange={e => updateRow(i, 'f1041_11', e.target.value)} />
        : v },
    { title: '地址', dataIndex: 'f1041_12', ellipsis: true,
      render: (v: string, _: F1041, i: number) => isEditing
        ? <Input size="small" value={v} onChange={e => updateRow(i, 'f1041_12', e.target.value)} />
        : v },
    { title: '電話', dataIndex: 'f1041_13', width: 150,
      render: (v: string, _: F1041, i: number) => isEditing
        ? <Input size="small" value={v} onChange={e => updateRow(i, 'f1041_13', e.target.value)} />
        : v },
    { title: '傳真', dataIndex: 'f1041_14', width: 150,
      render: (v: string, _: F1041, i: number) => isEditing
        ? <Input size="small" value={v} onChange={e => updateRow(i, 'f1041_14', e.target.value)} />
        : v },
    ...(isEditing ? [{
      title: '', width: 40,
      render: (_: unknown, __: F1041, i: number) => (
        <Button size="small" type="text" danger icon={<DeleteOutlined />} onClick={() => deleteRow(i)} />
      ),
    }] : []),
  ];

  return (
    <div>
      {isEditing && (
        <Button size="small" icon={<PlusOutlined />} onClick={addRow} className="mb-2">新增地址</Button>
      )}
      <Table dataSource={addresses} columns={columns} rowKey={(_, i) => String(i)}
        size="small" pagination={false} scroll={{ y: 240 }} />
    </div>
  );
});

export default Tab2Addresses;
